import laborCostImage from '../../assets/images/premium-features/labor-cost.png';
import budgetingImage from '../../assets/images/premium-features/budgeting.png';
import overtimeImage from '../../assets/images/premium-features/overtime.png';
import laborPercentageImage from '../../assets/images/premium-features/labor-percentage.png';
import { YOUTUBE_VIDEO_LABOR_COST, PREMIUM_FEATURE_NAMES } from '../../constants';

import laborCostPreviewUrl from './laborCostPreviewComponent.html';

class LaborCostPreviewCtrl {
  LABOR_COST_FEATURE_NAME = PREMIUM_FEATURE_NAMES.laborCost;

  constructor($sce) {
    'ngInject';

    Object.assign(this, { $sce });
  }

  $onInit() {
    this.youtubeVideoLaborCost = this.$sce.trustAsResourceUrl(YOUTUBE_VIDEO_LABOR_COST);
    this.laborCostImage = laborCostImage;
    this.budgetingImage = budgetingImage;
    this.overtimeImage = overtimeImage;
    this.laborPercentageImage = laborPercentageImage;
  }
}

export default {
  controller: LaborCostPreviewCtrl,
  controllerAs: 'ctrl',
  templateUrl: laborCostPreviewUrl,
};
